var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/fonts/OpenSans/opensans-bold.ttf": "cbec",
	"./assets/fonts/OpenSans/opensans-bold.woff": "abf4",
	"./assets/fonts/OpenSans/opensans-bold.woff2": "fbd4",
	"./assets/fonts/OpenSans/opensans-bolditalic.ttf": "9819",
	"./assets/fonts/OpenSans/opensans-bolditalic.woff": "12fe",
	"./assets/fonts/OpenSans/opensans-bolditalic.woff2": "e251",
	"./assets/fonts/OpenSans/opensans-extrabold.ttf": "f8ce7",
	"./assets/fonts/OpenSans/opensans-extrabold.woff": "db02",
	"./assets/fonts/OpenSans/opensans-extrabold.woff2": "c7e2",
	"./assets/fonts/OpenSans/opensans-extrabolditalic.ttf": "d9b51",
	"./assets/fonts/OpenSans/opensans-extrabolditalic.woff": "b66a",
	"./assets/fonts/OpenSans/opensans-extrabolditalic.woff2": "37ac",
	"./assets/fonts/OpenSans/opensans-italic.ttf": "fe34",
	"./assets/fonts/OpenSans/opensans-italic.woff": "d3b9",
	"./assets/fonts/OpenSans/opensans-italic.woff2": "a3b7",
	"./assets/fonts/OpenSans/opensans-light.ttf": "eb95",
	"./assets/fonts/OpenSans/opensans-light.woff": "2e0f",
	"./assets/fonts/OpenSans/opensans-light.woff2": "c0db",
	"./assets/fonts/OpenSans/opensans-lightitalic.ttf": "30f3",
	"./assets/fonts/OpenSans/opensans-lightitalic.woff": "39dc",
	"./assets/fonts/OpenSans/opensans-lightitalic.woff2": "9c22",
	"./assets/fonts/OpenSans/opensans-regular.ttf": "841a",
	"./assets/fonts/OpenSans/opensans-regular.woff": "9e6e",
	"./assets/fonts/OpenSans/opensans-regular.woff2": "63f8",
	"./assets/fonts/OpenSans/opensans-semibold.ttf": "ddb2",
	"./assets/fonts/OpenSans/opensans-semibold.woff": "f9b7",
	"./assets/fonts/OpenSans/opensans-semibold.woff2": "6595",
	"./assets/fonts/OpenSans/opensans-semibolditalic.ttf": "36ce",
	"./assets/fonts/OpenSans/opensans-semibolditalic.woff": "e54e",
	"./assets/fonts/OpenSans/opensans-semibolditalic.woff2": "d14c",
	"./assets/fonts/OpenSans/rage.woff": "6790",
	"./assets/fonts/notosans/NotoSans-VariableFont_wdth,wght.ttf": "508e",
	"./assets/images/build-reference/Screenshot 2026-05-26 032746.png": "d738",
	"./assets/images/contact-us/map-location-square.png": "1012",
	"./assets/images/contact-us/map-location.png": "1af6",
	"./assets/images/deadline/deadlines.png": "f315",
	"./assets/images/hero-banner/Flying_kid.png": "d504",
	"./assets/images/hero-banner/Flying_kid2.png": "8f0c",
	"./assets/images/hero-banner/answer-call-2.png": "a98d",
	"./assets/images/hero-banner/answer-call-mobile.png": "f3f7",
	"./assets/images/hero-banner/answer-call.png": "d2dd",
	"./assets/images/hero-banner/arrow-mobile.png": "20fe",
	"./assets/images/hero-banner/arrow.png": "47c2",
	"./assets/images/hero-banner/brain-mobile.png": "a0e7",
	"./assets/images/hero-banner/brain.png": "1586",
	"./assets/images/hero-banner/bulb-mobile.png": "d2db",
	"./assets/images/hero-banner/bulb.png": "c93d",
	"./assets/images/hero-banner/contact_us_city_view.png": "f9e5",
	"./assets/images/hero-banner/cross-road-mobile.png": "1ff9",
	"./assets/images/hero-banner/cross-road.png": "716e",
	"./assets/images/hero-banner/deadlines-mobile.png": "0bd5",
	"./assets/images/hero-banner/flying-kid-mobile.png": "0a1e",
	"./assets/images/hero-banner/flying-kid_old.png": "201c",
	"./assets/images/hero-banner/hanging-open.png": "5c2b",
	"./assets/images/hero-banner/leadership_team.png": "2b9b",
	"./assets/images/hero-banner/throw-mobile.png": "3c91",
	"./assets/images/hero-banner/throw.png": "295d",
	"./assets/images/hero-banner/wow-mobile.png": "f688",
	"./assets/images/hero-banner/wow.png": "eef2",
	"./assets/images/home/CTIM_w_trans.png": "213b",
	"./assets/images/home/HRDC.png": "ffa3",
	"./assets/images/home/LHDN.png": "5002",
	"./assets/images/home/MIA.jpg": "547f",
	"./assets/images/home/MIA_w_trans.png": "b04d",
	"./assets/images/home/SSM_w_trans.png": "b7f0",
	"./assets/images/home/Services_Connecting.jpg": "702c",
	"./assets/images/home/Services_connecting2.png": "243c",
	"./assets/images/home/Services_connecting_mobile.png": "cc4c",
	"./assets/images/home/contact.jpg": "2668",
	"./assets/images/home/financial.jpg": "a06f3",
	"./assets/images/home/homepage_career.png": "ed7f",
	"./assets/images/management-team/tan-lih-chen-v2.png": "6ffd",
	"./assets/images/management-team/tan-lih-chen.png": "2e3f",
	"./assets/images/management-team/tan-lih-tyng-2.png": "378f",
	"./assets/images/management-team/tan-lih-tyng-v2.png": "92e9",
	"./assets/images/management-team/tan-lih-tyng.png": "bd38",
	"./assets/images/services/company_incoporation.png": "d4c6",
	"./assets/images/services/company_secretarial.png": "2991",
	"./assets/images/services/employer_registration.png": "be0d",
	"./assets/images/services/icon-audit.png": "f3c6",
	"./assets/images/services/icon-files.png": "e88d",
	"./assets/images/services/icon-payroll.png": "cbe2",
	"./assets/images/services/icon-services.png": "2411",
	"./assets/images/services/icon-stamp.png": "dd47",
	"./assets/images/services/icon-statements.png": "df67",
	"./assets/images/services/icon-tax.png": "3087",
	"./assets/images/services/moving_forward.png": "8bb6",
	"./assets/images/services/moving_forward_mobile.png": "6539",
	"./assets/images/services/payroll_processing.png": "6560",
	"./assets/images/services/tax.png": "bfc5",
	"./assets/images/services/training.png": "cf39",
	"./assets/images/why-us/icon-cost.png": "4a2c",
	"./assets/images/why-us/icon-deadline.png": "1fe7",
	"./assets/images/why-us/icon-flexibility.png": "c0ec",
	"./assets/images/why-us/icon-professionals.png": "a011",
	"./assets/images/why-us/icon-time.png": "39a4",
	"./assets/images/why-us/icon-update.png": "87ac",
	"./assets/images/why-us/services-icon.png": "af24",
	"./assets/logo.png": "cf05",
	"./assets/logo_3d.png": "2d87",
	"./assets/logo_outline.png": "eab8",
	"./assets/logo_text.png": "dcbc",
	"./assets/logo_transparent.png": "c2fb",
	"./assets/logo_v2.png": "14c5",
	"./assets/logo_v3.png": "39d8",
	"./assets/logo_white.png": "428c",
	"./assets/scss/abstracts/_variables.scss": "faea",
	"./assets/scss/base/_fonts.scss": "e349",
	"./assets/scss/base/_reset.scss": "1ca3",
	"./assets/scss/components/_alert-modal.scss": "9a82",
	"./assets/scss/components/_app-badge.scss": "f26c",
	"./assets/scss/components/_capabilities-slider.scss": "0d22",
	"./assets/scss/components/_certificate.scss": "b806",
	"./assets/scss/components/_confirm-modal.scss": "f630",
	"./assets/scss/components/_contact-cards.scss": "98fc",
	"./assets/scss/components/_date-input.scss": "ba2a",
	"./assets/scss/components/_empty-state.scss": "9e68",
	"./assets/scss/components/_expertise-swiper.scss": "a3de",
	"./assets/scss/components/_feature.scss": "b977",
	"./assets/scss/components/_forms.scss": "7a51",
	"./assets/scss/components/_header-tile.scss": "0ab0",
	"./assets/scss/components/_hero-banner.scss": "a9ae",
	"./assets/scss/components/_password-input.scss": "f1eb",
	"./assets/scss/components/_phone-input.scss": "f96c",
	"./assets/scss/components/_quick-links.scss": "02ec",
	"./assets/scss/components/_select-input.scss": "d39d",
	"./assets/scss/components/_services-box.scss": "8f2e",
	"./assets/scss/components/_session-modal.scss": "181a",
	"./assets/scss/components/_tag.scss": "4f28",
	"./assets/scss/components/_tax-input.scss": "a61a",
	"./assets/scss/components/_tooltip.scss": "e3cf",
	"./assets/scss/components/_why-us.scss": "0199",
	"./assets/scss/components/_youtube-gallery.scss": "7b91",
	"./assets/scss/email_template/_general.scss": "f662",
	"./assets/scss/layout/_container.scss": "cd83",
	"./assets/scss/layout/_footer.scss": "fb8e",
	"./assets/scss/layout/_top-header.scss": "8da8",
	"./assets/scss/layout/_whats-app.scss": "88fd",
	"./assets/scss/main.scss": "c1c3",
	"./assets/scss/pages/_admin-panel.scss": "0283",
	"./assets/scss/pages/_admin-tasks.scss": "7f9f",
	"./assets/scss/pages/_contact.scss": "e117",
	"./assets/scss/pages/_deadline.scss": "9170",
	"./assets/scss/pages/_document-signed.scss": "9577",
	"./assets/scss/pages/_home.scss": "31b4",
	"./assets/scss/pages/_legal.scss": "8f66",
	"./assets/scss/pages/_login.scss": "dc66",
	"./assets/scss/pages/_our-team.scss": "dcdc",
	"./assets/scss/pages/_policy.scss": "ace8",
	"./assets/scss/pages/_reset-password.scss": "df4e",
	"./assets/scss/pages/_services.scss": "a595",
	"./assets/scss/pages/_user-panel.scss": "1e38",
	"./components/admin/AdminClientTable": "8e90",
	"./components/admin/AdminClientTable.vue": "8e90",
	"./components/admin/AdminEditClientModal": "cc8e",
	"./components/admin/AdminEditClientModal.vue": "cc8e",
	"./components/admin/AdminHeader": "a16e",
	"./components/admin/AdminHeader.vue": "a16e",
	"./components/admin/AdminOptionsModal": "1c08",
	"./components/admin/AdminOptionsModal.vue": "1c08",
	"./components/admin/AdminStatCards": "5061",
	"./components/admin/AdminStatCards.vue": "5061",
	"./components/admin/AdminTaskWidget": "3be2",
	"./components/admin/AdminTaskWidget.vue": "3be2",
	"./components/admin/AdminViewClientModal": "12c8",
	"./components/admin/AdminViewClientModal.vue": "12c8",
	"./components/bottomFooter": "beeb",
	"./components/bottomFooter.vue": "beeb",
	"./components/capabilitiesSlider": "e808",
	"./components/capabilitiesSlider.vue": "e808",
	"./components/certificate": "f6e4",
	"./components/certificate.vue": "f6e4",
	"./components/containerStyle": "78ee",
	"./components/containerStyle.vue": "78ee",
	"./components/expertiseSwiper": "6ae8",
	"./components/expertiseSwiper.vue": "6ae8",
	"./components/featureTiles": "29d8",
	"./components/featureTiles.vue": "29d8",
	"./components/form/BillingDatePicker": "039d",
	"./components/form/BillingDatePicker.vue": "039d",
	"./components/form/ContactCards": "2e5b",
	"./components/form/ContactCards.vue": "2e5b",
	"./components/form/DateInput": "f416",
	"./components/form/DateInput.vue": "f416",
	"./components/form/DobInput": "1a9c",
	"./components/form/DobInput.vue": "1a9c",
	"./components/form/EmailInput": "fc44",
	"./components/form/EmailInput.vue": "fc44",
	"./components/form/PasswordInput": "a1e3",
	"./components/form/PasswordInput.vue": "a1e3",
	"./components/form/PhoneInput": "bcd5",
	"./components/form/PhoneInput.vue": "bcd5",
	"./components/form/PrefixInput": "4c97",
	"./components/form/PrefixInput.vue": "4c97",
	"./components/form/SelectInput": "7b0c",
	"./components/form/SelectInput.vue": "7b0c",
	"./components/form/TaxInput": "9fbf",
	"./components/form/TaxInput.vue": "9fbf",
	"./components/form/TextInput": "e94b",
	"./components/form/TextInput.vue": "e94b",
	"./components/form/TextareaInput": "0d12",
	"./components/form/TextareaInput.vue": "0d12",
	"./components/gmap": "ab2d",
	"./components/gmap.vue": "ab2d",
	"./components/headerTile": "d214",
	"./components/headerTile.vue": "d214",
	"./components/heroBanner": "7be5",
	"./components/heroBanner.vue": "7be5",
	"./components/jobCard": "6c30",
	"./components/jobCard.vue": "6c30",
	"./components/messageForm": "7561",
	"./components/messageForm.vue": "7561",
	"./components/ourTeam": "1169",
	"./components/ourTeam.vue": "1169",
	"./components/quickLinksCarousal": "c048",
	"./components/quickLinksCarousal.vue": "c048",
	"./components/servicesBox": "5fb3",
	"./components/servicesBox.vue": "5fb3",
	"./components/shared/AdHocDeadlineForm": "fce2",
	"./components/shared/AdHocDeadlineForm.vue": "fce2",
	"./components/shared/AlertModal": "a32f",
	"./components/shared/AlertModal.vue": "a32f",
	"./components/shared/AppBadge": "54de",
	"./components/shared/AppBadge.vue": "54de",
	"./components/shared/AppButton": "5c40",
	"./components/shared/AppButton.vue": "5c40",
	"./components/shared/AppDivider": "c9ae",
	"./components/shared/AppDivider.vue": "c9ae",
	"./components/shared/AppTooltip": "b315",
	"./components/shared/AppTooltip.vue": "b315",
	"./components/shared/ClientDetailsModal": "d2ad",
	"./components/shared/ClientDetailsModal.vue": "d2ad",
	"./components/shared/ConfirmModal": "0ba1",
	"./components/shared/ConfirmModal.vue": "0ba1",
	"./components/shared/EmptyState": "bcb9",
	"./components/shared/EmptyState.vue": "bcb9",
	"./components/shared/GlobalLoader": "444b",
	"./components/shared/GlobalLoader.vue": "444b",
	"./components/shared/SessionModal": "fa55",
	"./components/shared/SessionModal.vue": "fa55",
	"./components/shared/TaskCalendarView": "ce93",
	"./components/shared/TaskCalendarView.vue": "ce93",
	"./components/tag": "ab01",
	"./components/tag.vue": "ab01",
	"./components/topHeader": "8770",
	"./components/topHeader.vue": "8770",
	"./components/whatsApp": "8893",
	"./components/whatsApp.vue": "8893",
	"./components/youtubeGallery": "d1c3",
	"./components/youtubeGallery.vue": "d1c3",
	"./i18n": "9225",
	"./i18n.js": "9225",
	"./locales/cn.json_backup": "75c5",
	"./locales/en": "edd4",
	"./locales/en.json": "edd4",
	"./main": "56d7",
	"./main.js": "56d7",
	"./mixins/adminSessionMixin": "fe83",
	"./mixins/adminSessionMixin.js": "fe83",
	"./mixins/bodyScrollLockMixin": "14f0",
	"./mixins/bodyScrollLockMixin.js": "14f0",
	"./mixins/countriesMixin": "a29b",
	"./mixins/countriesMixin.js": "a29b",
	"./mixins/fetchOnceMixin": "e96d",
	"./mixins/fetchOnceMixin.js": "e96d",
	"./plugins/bootstrap-vue": "135e",
	"./plugins/bootstrap-vue.js": "135e",
	"./plugins/fontawesome-vue": "5f3a",
	"./plugins/fontawesome-vue.js": "5f3a",
	"./plugins/multiselect-vue": "e80a",
	"./plugins/multiselect-vue.js": "e80a",
	"./plugins/swiper-vue": "3356",
	"./plugins/swiper-vue.js": "3356",
	"./plugins/youtube": "341a",
	"./plugins/youtube.js": "341a",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./services/api": "7424",
	"./services/api.js": "7424",
	"./services/api.js_bk_v2": "33a4",
	"./services/crypto": "fd78",
	"./services/crypto.js": "fd78",
	"./services/loader": "2c8d",
	"./services/loader.js": "2c8d",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./utils/bodyScrollLock": "c258",
	"./utils/bodyScrollLock.js": "c258",
	"./utils/clientOptions": "deb5",
	"./utils/clientOptions.js": "deb5",
	"./utils/cosecParser": "05d9",
	"./utils/cosecParser.js": "05d9",
	"./views/Company-Registration-Form": "7e6c",
	"./views/Company-Registration-Form.vue": "7e6c",
	"./views/Contact-Us": "c704",
	"./views/Contact-Us.vue": "c704",
	"./views/Deadline": "88d1",
	"./views/Deadline.vue": "88d1",
	"./views/Document-Signed": "4afb",
	"./views/Document-Signed.vue": "4afb",
	"./views/Home": "bb51",
	"./views/Home.vue": "bb51",
	"./views/Legal": "519a",
	"./views/Legal.vue": "519a",
	"./views/Management-Team": "68ee",
	"./views/Management-Team.vue": "68ee",
	"./views/Policy": "2da4",
	"./views/Policy.vue": "2da4",
	"./views/Reset-Password": "ad29",
	"./views/Reset-Password.vue": "ad29",
	"./views/Services": "f23e",
	"./views/Services.vue": "f23e",
	"./views/Why-Us": "c023",
	"./views/Why-Us.vue": "c023",
	"./views/admin/Admin-Login": "735f",
	"./views/admin/Admin-Login.vue": "735f",
	"./views/admin/Admin-Panel": "13cf",
	"./views/admin/Admin-Panel.vue": "13cf",
	"./views/admin/AdminEditClient": "ab5a",
	"./views/admin/AdminEditClient.vue": "ab5a",
	"./views/admin/AdminEmailBlast": "0f3b",
	"./views/admin/AdminEmailBlast.vue": "0f3b",
	"./views/admin/AdminEmailBlastGeneral": "cb21",
	"./views/admin/AdminEmailBlastGeneral.vue": "cb21",
	"./views/admin/AdminEmailBlastMonthly": "2a2e",
	"./views/admin/AdminEmailBlastMonthly.vue": "2a2e",
	"./views/admin/AdminNewClient": "a30f",
	"./views/admin/AdminNewClient.vue": "a30f",
	"./views/admin/AdminTaskBilling": "7376",
	"./views/admin/AdminTaskBilling.vue": "7376",
	"./views/admin/AdminTaskCosec": "1d8c",
	"./views/admin/AdminTaskCosec.vue": "1d8c",
	"./views/admin/AdminTaskIncorporation": "6fa5",
	"./views/admin/AdminTaskIncorporation.vue": "6fa5",
	"./views/admin/AdminTaskTax": "5ea9",
	"./views/admin/AdminTaskTax.vue": "5ea9",
	"./views/admin/AdminUserManagement": "934a",
	"./views/admin/AdminUserManagement.vue": "934a",
	"./views/client/Login": "754d",
	"./views/client/Login.vue": "754d",
	"./views/client/User-Panel": "6b07",
	"./views/client/User-Panel.vue": "6b07",
	"./views/staff/Staff-Login": "f4fd",
	"./views/staff/Staff-Login.vue": "f4fd",
	"./views/staff/StaffPanel": "0884",
	"./views/staff/StaffPanel.vue": "0884"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";